import React from 'react';

import { ChipListInput } from 'components/ChipListInput/ChipListInput';

interface ITagsSectionProps {
  items: string[];
  onItemsChange: (items: string[]) => void;
  inputTestId?: string;
  listTestId?: string;
}

export const TagsSection: React.FC<ITagsSectionProps> = ({
  items,
  onItemsChange,
  inputTestId,
  listTestId
}): React.ReactElement => (
  <ChipListInput
    items={items}
    onItemsChange={onItemsChange}
    title="Tags"
    description="Create or add tags to your offer"
    inputLabel="Tag Name"
    placeholder="Search Tag"
    inputTestId={inputTestId}
    listTestId={listTestId}
  />
);
